import { apiPost } from '../../../utils/api';

export const upgradeUser = (userID, country, account_type) => {
  return apiPost('/user/' + userID, 'upgrade_to_account', {
    country,
    account_type,
  });
};
